import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.store_management_bulk_edit.worker_list_table.';
export const selectedStoreListTableHeader = [
    {
        title: t(`${lc}hub_name`),
        align: 'start',
        value: 'hubName',
        width: 233,
    },
    {
        title: t(`${lc}worker_name`),
        align: 'start',
        value: 'storeName',
        width: 233,
    },
];
